import React from 'react';
import type { PatientPreset } from '../types/simulation';
export type ReadoutField = 'patient' | 'product' | 'dose' | 'response';
type ClinicalReadoutProps = {
  patient: PatientPreset;
  product: string | null;
  dose: string | null;
  response: {
    label: string;
    className: string;
  } | null;
  active: ReadoutField | null;
};
type Cell = {
  key: ReadoutField | 'weight' | 'amh';
  label: string;
  value: string;
  unit?: string;
  className?: string;
};
export function ClinicalReadout({
  patient,
  product,
  dose,
  response,
  active
}: ClinicalReadoutProps) {
  const cells: Cell[] = [{
    key: 'patient',
    label: 'PATIENT',
    value: `PT-${patient.id}`,
    unit: `F · ${patient.age} y`
  }, {
    key: 'weight',
    label: 'BODY WEIGHT',
    value: String(patient.weight),
    unit: 'kg'
  }, {
    key: 'amh',
    label: 'AMH',
    value: String(patient.amh),
    unit: 'pmol/L'
  }, {
    key: 'product',
    label: 'FSH',
    value: product ?? '—'
  }, {
    key: 'dose',
    label: 'STARTING DOSE',
    value: dose ?? '—'
  }, {
    key: 'response',
    label: 'RESPONSE TENDENCY',
    value: response?.label ?? '—',
    className: response?.className
  }];
  return <dl className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6" data-id="element-6" data-mp="tqt9pvxmsyzt">
      {cells.map((c, i) => <div key={c.key} className={`border-rule px-5 py-3 md:px-6 ${i > 0 ? 'lg:border-l' : ''} ${i % 2 === 1 ? 'border-l' : ''} ${i > 1 ? 'border-t lg:border-t-0' : ''}`} data-id="element-7" data-mp="17holbfzilu73" data-mpi={i}>
          <dt className="font-mono text-[10px] tracking-[0.16em] text-graphite/70" data-id="element-8" data-mp="1he1d28bi1xz7">{c.label}</dt>
          <dd className={`mt-1 truncate font-mono text-sm tabular-nums ${c.className ?? (c.key === active ? 'text-accent' : 'text-ink')}`} data-id="element-9" data-mp="1cfzvjrtq26pu">
            {c.value}
            {c.unit && <span className="ml-1 text-[11px] text-graphite/60" data-id="element-10" data-mp="1lf3d2rd8qe28">{c.unit}</span>}
          </dd>
        </div>)}
    </dl>;
}